import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/ranking?q=${encodeURIComponent(q)}`);
  };

  return (
    <section className="relative flex min-h-[640px] w-full items-center overflow-hidden md:min-h-[680px]">
      <img
        src="https://readdy.ai/api/search-image?query=Immersive%20vibrant%20anime%20cityscape%20banner%20with%20soaring%20starships%20and%20neon%20glowing%20characters%2C%20deep%20teal%20and%20coral%20orange%20nebula%20sky%2C%20cinematic%20wide%20shot%2C%20energetic%20youthful%20atmosphere%2C%20high%20detail%20digital%20art&width=1800&height=1000&seq=hero-anime-2026&orientation=landscape"
        alt="漫番志动漫综合门户首页背景"
        title="漫番志 卡通动漫综合 - 新番剧场版OVA导航"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/55 to-background-50" />

      <div className="relative mx-auto w-full max-w-7xl px-4 py-28 md:px-6 md:py-32">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full bg-background-100/70 px-4 py-1.5 text-sm font-bold text-secondary-400 ring-1 ring-secondary-400/30">
          <i className="ri-flashlight-fill" /> 本季新番 · 剧场版 · OVA 一站收录
        </p>
        <h1 className="font-heading text-4xl leading-tight text-foreground-950 md:text-6xl">
          追番，从这里开始
          <span className="text-gradient-warm"> —— 漫番志</span>
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
          卡通动漫综合分类导航，新番速递、热门排行、剧场版、OVA 按类整理，实时更新当下值得追的作品。
          分类清晰，入口直达，让每一部好作品都不被错过。
        </p>

        <form
          onSubmit={submit}
          className="mt-8 flex max-w-xl items-center overflow-hidden rounded-full bg-background-100/90 ring-1 ring-background-300/70 focus-within:ring-2 focus-within:ring-primary-500"
        >
          <i className="ri-search-line pl-5 text-foreground-500" />
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索作品名称或类型，如「热血」「剧场版」…"
            className="w-full bg-transparent px-3 py-3.5 text-sm text-foreground-950 outline-none placeholder:text-foreground-500"
          />
          <button
            type="submit"
            className="m-1 whitespace-nowrap rounded-full bg-gradient-to-r from-primary-500 to-primary-600 px-5 py-2.5 text-sm font-bold text-background-50 transition-opacity hover:opacity-90"
          >
            搜索追番
          </button>
        </form>

        <div className="mt-7 flex flex-wrap items-center gap-2.5">
          <span className="text-sm text-foreground-500">热门分类：</span>
          {categories.slice(0, 6).map((c) => (
            <button
              key={c.slug}
              type="button"
              onClick={() => navigate(`/category/${c.slug}`)}
              className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100/70 px-3.5 py-1.5 text-xs text-foreground-700 ring-1 ring-background-300/60 transition-all hover:bg-primary-500 hover:text-background-50 hover:ring-primary-500"
            >
              <i className={c.icon} />
              {c.name}
            </button>
          ))}
        </div>

        <div className="mt-10 grid max-w-2xl grid-cols-3 gap-4">
          {[
            { num: "120+", label: "精品片单" },
            { num: "8", label: "细分分类" },
            { num: "9.2", label: "站内平均评分" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-2xl bg-background-100/60 p-4 text-center ring-1 ring-background-300/50 backdrop-blur-sm"
            >
              <p className="font-heading text-2xl text-secondary-400 md:text-3xl">{s.num}</p>
              <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}